module.exports = __webpack_public_path__ + "static/img/Store-9.d8c9569b.png";